Vue.component('adminKeys', {
  template: templates.adminKeys,
  data() {
    return {
      model: {
        edit: false,
        key: {
          id: null,
          name: null,
          description: null,
          uses: null,
          active: false
        },
        keys: {}
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      keyService.get()
        .then(function (response) {
          for (let d of response.data) {
            d.image = `/images/keys/${d.id}.png`;
            d.video = `/videos/keys/${d.id}.webm`;
            data[`${d.id}`] = d;
          }
          c.model.keys = data;
          c.$root.$emit('getKeys', data);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    edit(id) {
      const c = this;
      let data = c.model.keys[`${id}`];

      if (id == c.model.key.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }
      
      c.model.key = {
        id: id,
        name: data.name,
        description: data.description,
        uses: data.uses,
        active: data.active
      }
    },
    add() {
      const c = this;
      c.model.edit = true;
    },
    save() {
      const c = this;

      const data = c.model.key;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }

      if (!data.description) {
        utils.alert.error('Description is required');
        return;
      }
      
      keyService.save(data)
        .then(function (response) {

          if (data.id) {
            c.model.keys[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.keys[`${data.id}`] = data;
          }

          c.reset();
          
          utils.alert.success('Saved!');
          
        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });
    },
    upload() {
      const c = this;

      let data = new FormData();
      data.append('file', this.$refs.file.files[0]);
      data.append('type', 'keys');
      data.append('id', c.model.key.id);

      uploadService.uploadFile(data)
        .then(function (response) {
          utils.alert.success('File uploaded!');
        })
        .catch(function (error) {
          utils.alert.error('File failed to uploaded.');
        });
    },
    reset() {
      const c = this;
      c.model.edit = false;
      
      c.model.key = {
        id: null,
        name: null,
        description: null,
        uses: null,
        active: false
      }
    }
  }
});